import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { RouterModule } from '@angular/router';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../Model/utility/utility.service';
import moment from 'moment';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { CalendarService } from '../Model/Calendar/calendar.service';
import { SessionService } from '../Util/Session/session.service';
import { AdminLeaveHistoryComponent } from '../admin-leave-history/admin-leave-history.component';
import { AdminRegularizationHistoryComponent } from '../admin-regularization-history/admin-regularization-history.component';
import { AdminOutdoorHistoryComponent } from '../admin-outdoor-history/admin-outdoor-history.component';
import { AdminCompoffHistoryComponent } from '../admin-compoff-history/admin-compoff-history.component';
import { AdminCompoffConsumeHistoryComponent } from '../admin-compoff-consume-history/admin-compoff-consume-history.component';
import { AdminAttendanceViewComponent } from '../admin-attendance-view/admin-attendance-view.component';
import { AdminReimbursementHistoryComponent } from '../admin-reimbursement-history/admin-reimbursement-history.component';

@Component({
  selector: 'app-admin-leave-management',
  standalone: true,
  imports: [LoaderComponent, FormsModule, CommonModule, NgSelectModule, NgbDatepickerModule, DataTablesModule, RouterModule, AdminLeaveHistoryComponent, AdminRegularizationHistoryComponent, AdminOutdoorHistoryComponent, AdminCompoffHistoryComponent, AdminCompoffConsumeHistoryComponent,
    AdminAttendanceViewComponent, AdminReimbursementHistoryComponent],
  templateUrl: './admin-leave-management.component.html',
  styleUrl: './admin-leave-management.component.scss'
})
export class AdminLeaveManagementComponent {

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  @ViewChild('adminattendanceview') adminAttendanceView!: AdminAttendanceViewComponent;
  isDisabled: boolean = false;
  showEmpDetail: boolean = false;
  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  TableDatas: any[] = [];
  Employees: any[] = [];
  calendarDataSummary: any[] = [];
  EmployeeLeave = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private comboload: ComboService,
    public common: CommonService,
    private toast: ToastService,
    private utility: UtilityService,
    protected dateFormat: CustomDateParserFormatter,
    private Calendar: CalendarService,
    private session: SessionService,
    private cd: ChangeDetectorRef
  ) {
    // this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
    this.common.CompanyParameter();
    this.user = this.session.GetUserDetails();
    // this.AttendanceDetail.EmpMasterId = 21;
    this.ToDayDate = this.dateFormat.parse(moment(Date()).format("DD MMM YYYY"));
    this.user.EmpType = 'front';
  }

  search() {

  }

  user: any;
  Comment = '';
  Colour1 = '';
  Colour2 = '';

  ngOnInit() {
    this.ComboLoad('Branch');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  filter = {
    AttendanceDate: null as any
  }

  Duration: string = '0h 0m 0s';
  isShowAttendaceBtn: boolean = false;
  CurrentTime = null as any;
  IntervalId: any;
  ToDayDate = null as any;
  LateCheckInDuration: string = '0h 0m 0s';

  Filter = {
    Date: '' as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    Code: '',
    EmpCode: '' as any,
    // MonthName: null as any,
    EmployeeId: null as any,
    IsWithdraw: false,
    EmpType: 'FRONT',
    EmpPhoto: '',
    EmpName: '',
    EmpDesignation: '',
    EmpJoiningDate: ''
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': this.Filter.SiteId,
      'EmpType': 'front',
      'EmpCode': this.Filter.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } else if (Combotype == 'EmpLoadForRegularization') {
            if (this.Filter.BranchId == null) {
              this.toast.show({ message: 'Kindly select atleast Branch', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            if (response.ComboLoad.length == 0) {
              this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            this.TableDatas = response.ComboLoad;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  activeTab: string = '';

  setTab(tab: string) {
    if(this.Filter.EmployeeId == null){
      this.toast.show({message: 'Please Select Employee', type: toastTypeEnum.warning});
      return;
    }
    this.cd.detectChanges();
    if (this.adminAttendanceView) {
      console.log(this.adminAttendanceView);
      this.adminAttendanceView.EmployeeId = this.Filter.EmployeeId;
      this.adminAttendanceView.EmpName = this.Filter.EmpName;
      this.adminAttendanceView.EmpDesignation = this.Filter.EmpDesignation;
      this.adminAttendanceView.EmpPhoto = this.Filter.EmpPhoto;
      this.adminAttendanceView.EmpPhoto = this.Filter.EmpPhoto;
      this.adminAttendanceView.search();
    }
    this.activeTab = tab;
    this.showEmpDetail = true;
    this.SelectDate('RegistrationDate', null, null);
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.ToDayDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
        }
        console.log(this.ToDayDate);
        this.ESS_GetESSAttendanceSummaryWeb(this.dateFormat.fullmonth[this.ToDayDate.month - 1], this.ToDayDate.year);
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }


  ESS_GetESSAttendanceSummaryWeb(Month: String, Year: String) {
    this.calendarDataSummary = [];
    this.Calendar.ESS_GetESSAttendanceSummaryWeb({ MonthName: Month, YearName: Year, EmpMasterID: this.Filter.EmployeeId, }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          console.log(response.Table);
          this.calendarDataSummary = response.Table;
          this.stats.present = this.calendarDataSummary.find((e: any) => e.Type == 'Present').Count;
          this.stats.absent = this.calendarDataSummary.find((e: any) => e.Type == 'Absent').Count;
          this.stats.weekoff = this.calendarDataSummary.find((e: any) => e.Type == 'Week Off').Count;
        }else{

        }

      },
      complete: () => { },
      error: (error) => { },
    });
  }

  AdminAttendanceManagementLoad(SelectType: any) {
    this.isDisabled = true;
    this.utility.AdminAttendanceManagementEmployeesLoad({
      SelectType: SelectType,
      BranchID: this.Filter.BranchId,
      ClientID: this.Filter.ClientId,
      SiteID: this.Filter.SiteId,
      EmpType: this.Filter.EmpType,
      EmpCode: this.Filter.Code,
      EmpMasterID: null,
      UserMasterID: 1,
    }).subscribe({
      next: (response) => {
        this.Employees = response;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onEmployeeChange() {
    const employee = this.Employees.find((e: any) => e.EmpMasterID == this.Filter.EmployeeId);
    if (employee) {
      this.Filter.EmpPhoto = employee.Photo;
      this.Filter.EmpName = employee.FullName;
      this.Filter.EmpDesignation = employee.DesignationName;
      this.Filter.EmpCode = employee.EmpCode;
      this.Filter.EmpJoiningDate = employee.JoiningDate;
    } else {
      this.Filter.EmpPhoto = '';
      this.Filter.EmpName = '';
      this.Filter.EmpDesignation = '';
      this.Filter.EmpCode = '';
      this.Filter.EmpJoiningDate = '';
    }
    this.activeTab = '';
    this.showEmpDetail = false;
  }

  stats = {
    present: 0,
    absent: 0,
    leave: 0,
    late: 0,
    weekoff: 0
  };
}